import { state as breadcrumbsState } from 'atoms/breadcrumbs';
import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { i18nStrings } from 'utils/constants';

import { routes } from '../../constants';
import SignIn from './SignIn';
import styles from './SignIn.module.scss';

const SignInContainer = () => {
    const setBreadcrumbs = useSetRecoilState(breadcrumbsState);

    useEffect(() => {
        setBreadcrumbs([
            {
                text: i18nStrings.appName,
                href: routes.landingPage,
            },
            {
                text: i18nStrings.signIn.title,
                href: routes.joinEvent,
            },
        ]);
    }, []);

    return (
        <div className={styles.loginContainer}>
            <SignIn />
        </div>
    );
};

export default SignInContainer;
